<template>
  <div class="export-content">
    <div
      v-loading="loading"
      class="export-content-con"
      element-loading-text="导入中..."
    >
      <div class="export-content-con-header">
        <h3>导入内容（EXCEL）</h3>
        <ds-iconfont
          class="close"
          icon-class="icon-ds-guanbi1"
          @click.native="close"
        />
      </div>
      <div class="export-content-con-container">
        <div class="btn-group">
          <mk-button-biz
            class="export-xlsx"
            @click="exportXlsx"
          >
            <ds-iconfont icon-class="iconxiazai" />
            <span class="txt">下载导入模板</span>
          </mk-button-biz>
        </div>
        <drag-upload
          @clear="clear"
          @upload-success="uploadSuccess"
        />
      </div>
      <div class="export-content-con-tips">
        <div class="tit">
          导入须知
        </div>
        <div class="con">
          1. 文件必须为xlsx格式(如果为xls格式请另存为xlsx格式)
          <br>
          2. 请注意必填字段，必填字段未填写则会导入失败
          <br>
          3. 不支持导入存在多个工作表的文件，默认只导入第一个工作表
          <br>
          4. 导入时若出现重复内容、错误文件夹名称等，则会导入失败
          <br>
          5. 尽量避免合并单元格，否则导入可能存在异常
          <br>
          6. 文件内容不能包含公式，否则可能影响导入结果
          <br>
          7. 文件不允许空行存在，否则可能影响导入结果
        </div>
      </div>
      <div class="export-content-con-handle">
        <div class="btn-group">
          <mk-button-biz
            width="72px"
            height="32px"
            @click="cancel"
          >
            取消
          </mk-button-biz>
          <mk-button-biz
            type="primary"
            width="72px"
            height="32px"
            :disabled="file === ''"
            @click="confirm"
          >
            确认
          </mk-button-biz>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DragUpload from '@components/drag-upload'
import { CONVERSATIONAPIS } from '@api'
export default {
  components: {
    DragUpload
  },
  props: {
    type: {
      type: String,
      default: 'common'
    }
  },
  data () {
    return {
      file: '',
      loading: false
    }
  },
  // computed: {
  //   downloadUrl () {
  //     if (this.type === 'common') {
  //       return 'https://cf-markting-test-1256732272.cos.ap-shanghai.myqcloud.com/mkSystem/conversations_skills_mkCommonWord_template.xlsx'
  //     } else {
  //       return 'https://cf-markting-test-1256732272.cos.ap-shanghai.myqcloud.com/mkSystem/conversations_skills_mkQuestion_template.xlsx'
  //     }
  //   }
  // },
  methods: {
    exportXlsx () {
      if (this.type === 'common') {
        this.util.download({
          href: location.origin + '/img/企业常用语导入模板.xlsx'
        })
      } else {
        this.util.download({
          href: location.origin + '/img/百问百答导入模板.xlsx'
        })
      }
    },
    async confirm () {
      this.loading = true
      // 确认事件
      let formData = new FormData()
      formData.append('excel', this.file)
      formData.append('cType', this.type === 'common' ? 'mkCommonWords' : 'mkQuestions')
      const { success, data } = await CONVERSATIONAPIS.ImportExcelApi.pExcelImportPost(formData)
      if (success && data.msg === 'success') {
        this.$emit('upload-success', data)
      } else {
        this.$emit('upload-fail', data.msg)
      }
      this.loading = false
    },
    cancel () {
      this.$confirm('导入未成功，是否要关闭，确认后关闭弹窗', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {
        this.$emit('close')
      }).catch(() => {})
    },
    close () {
      this.$emit('close')
    },
    clear () {
      this.file = ''
    },
    uploadSuccess (file) {
      this.$message({
        type: 'success',
        message: '上传成功，请点击确认进行导入'
      })
      this.file = file
    }
  }
}
</script>
<style lang="scss" scoped>
.export-content {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.32);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  /deep/ .export-xlsx {
    .iconxiazai {
      font-size: 12px;
    }

    .txt {
      margin-left: 4px;
    }
  }

  .export-content-con {
    width: 800px;
    border-radius: 4px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .export-content-con-header {
      width: 100%;
      height: 48px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: space-between;

      h3 {
        font-size: 14px;
        color: #262626;
        margin-left: 20px;
      }

      .close {
        font-size: 14px;
        color: #bfbfbf;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    .export-content-con-container {
      margin: 10px 20px 20px 20px;
    }

    .export-content-con-handle {
      width: 100%;
      height: 56px;
      border-top: 1px solid #e8e8e8;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .btn-group {
        margin-right: 10px;
      }
    }

    .export-content-con-tips {
      width: 386px;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 15px 8px;
      background: rgba(0, 0, 0, 0.02);
      margin-bottom: 30px;
      position: relative;

      .tit,
      .con {
        font-size: 13px;
        line-height: 18px;
        color: #595959;
      }

      .tit {
        font-weight: 500;
        text-align: center;
        margin-bottom: 8px;
      }
    }
  }

  /deep/ .el-button {
    font-size: 13px;
  }

  /deep/ .el-progress__text {
    margin-left: 16px;
  }
}
</style>
